import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const Brokerage = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const brokerageModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/brokerage',
    name: 'brokerage',
    component: Brokerage,
    meta: {
      title: 'Corretaje',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
